module.exports = __webpack_public_path__ + "img/smoker-selected.8d744271.svg";